// extracted by mini-css-extract-plugin
module.exports = {"map-loading-container":"MapLoading_map-loading-container__DdcVR","loading-icon":"MapLoading_loading-icon__KH4Am","spin":"MapLoading_spin__UkFDs"};